export enum AccessRoleCodesEnum {
  /**
   * =================================================================================
   *  GENERAL ACCCESS CODES
   * =================================================================================
   */

  // ADMIN DATA PLAYERS
  ADMIN_DATA_PLAYERS_GET_PLAYER_CARD = 'ADM_PC_PCS_90',

  // TAGS
  TAGS_ADMIN = 'ADM_PT_LBR_61', // ADMIN TAGS
  TAGS_CREATE = 'ADM_PT_CRT_62',
  TAGS_DELETE = 'ADM_PT_DLT_67',

  // SETTINGS
  GAMIFICATION_SETTINGS_EDIT = '',
  SETTINGS_USERS = 'CRM_U_GUL_01',
  SETTINGS_USERS_EDIT = 'CRM_U_EDT_03',
  SETTINGS_USERS_CREATE = 'CRM_U_CRT_02',
  SETTINGS_USERS_DELETE = 'CRM_U_DLT_04',
  SETTINGS_ROLES = 'CRM_R_GRL_05',
  SETTINGS_ROLES_CREATE = 'CRM_R_CRT_06',
  SETTINGS_ROLES_EDIT = 'CRM_R_EDT_07',
  SETTINGS_ROLES_DELETE = 'CRM_R_DLT_08',
  SETTINGS_USER_EDIT_PROFILE = 'CRM_U_EDI_153',
  SETTINGS_USER_LOGS_LIBRARY = 'ADM_UL_LBR_151',

  /**
   * =================================================================================
   *  CRM ACCCESS CODES
   * =================================================================================
   */

  // CAMPAIGNS
  CAMPAIGNS_TABLE = 'CRM_C_LBR_45',
  CAMPAIGNS_CREATE = 'CRM_C_CRC_47',
  CAMPAIGNS_EDIT = 'CRM_C_UPD_49',
  CAMPAIGNS_DUPLICATE = 'CRM_C_DUP_48',
  CAMPAIGNS_DELETE = 'CRM_C_ARC_50',
  CAMPAIGNS_ARCHIVE = 'CRM_C_GTA_46',

  // ANALYTICS
  ANALYTICS_TABLE = 'CRM_A_LBR_25',
  ANALYTICS_GENERAL_STATS = 'CRM_A_GST_26',
  ANALYTICS_SEND_ACTIVITY_DETAILS = 'CRM_A_SAD_22',
  ANALYTICS_SEND_ACTIVITY_EVENTS = 'CRM_A_SAE_23',
  ANALYTICS_HISTORY = 'CRM_A_HIS_205',

  // SEGMENTATION
  SEGMENTATION_TABLE = 'CRM_S_LBR_27',
  SEGMENTATION_CREATE = 'CRM_S_CRT_29',
  SEGMENTATION_EDIT = 'CRM_S_UPD_31',
  SEGMENTATION_DUPLICATE = 'CRM_S_DUP_30',
  SEGMENTATION_DELETE = 'CRM_S_ARC_32',
  SEGMENTATION_ARCHIVE = 'CRM_S_ARL_28',

  // EMAIL
  EMAIL_TABLE = 'CRM_ME_LBR_33',
  EMAIL_CREATE = 'CRM_ME_CRT_36',
  EMAIL_EDIT = 'CRM_ME_UPT_37',
  EMAIL_DUPLICATE = 'CRM_ME_DUP_38',
  EMAIL_DELETE = 'CRM_ME_ACT_39',
  EMAIL_ARCHIVE = 'CRM_ME_GAT_34',
  EMAIL_SEND = 'CRM_ME_SND_35',

  // SMS
  SMS_TABLE = 'CRM_MS_LBR_40',
  SMS_ARCHIVE = 'CRM_MS_GAT_214',
  SMS_CREATE = 'CRM_MS_CRT_42',
  SMS_EDIT = 'CRM_MS_UPT_43',
  SMS_DUPLICATE = 'CRM_MS_DUP_44',
  SMS_SEND = 'CRM_MS_SND_41',
  SMS_DELETE = 'CRM_MS_DLT_215',

  // CUSTOM TRIGGER
  CUSTOM_TRIGGER_TABLE = 'CRM_CT_LBR_143',
  CUSTOM_TRIGGER_ARCHIVE = 'CRM_CT_GAR_216',
  CUSTOM_TRIGGER_CREATE = 'CRM_CT_CRT_144',
  CUSTOM_TRIGGER_EDIT = 'CRM_CT_EDT_145',
  CUSTOM_TRIGGER_DELETE = 'CRM_CT_DLT_146',
  CUSTOM_TRIGGER_DUPLICATE = '',

  // MEDIA DATABASE
  MEDIA_DATABASE_TABLE = 'CRM_MD_GET_54',
  MEDIA_DATABASE_UPLOAD = 'CRM_MD_UPL_51',
  MEDIA_DATABASE_DELETE = 'CRM_MD_DLT_52',
  MEDIA_DATABASE_CREATE = 'CRM_MD_CRT_53',

  // FREQUENCY CAP
  FREQUENCY_CAP_TABLE = 'CRM_FC_LBR_147',
  FREQUENCY_CAP_CREATE = 'CRM_FC_CRT_148',
  FREQUENCY_CAP_EDIT = 'CRM_FC_EDT_149',
  FREQUENCY_CAP_DELETE = 'CRM_FC_DLT_150',

  // UNSUBSCRIBE REPORT CRM
  UNSUBSCRIBE_REPORT_CRM_TABLE = '',

  // WEB PUSH
  WEB_PUSH_TABLE = '',
  WEB_PUSH_ARCHIVE = '',
  WEB_PUSH_CREATE = '',
  WEB_PUSH_EDIT = '',
  WEB_PUSH_DUPLICATE = '',
  WEB_PUSH_SEND = '',
  WEB_PUSH_DELETE = '',

  // ONSITE
  ONSITE_TABLE = 'CRM_MO_LBR_154',
  ONSITE_ARCHIVE = 'CRM_MO_LBR_154',
  ONSITE_CREATE = 'CRM_MO_CRT_155',
  ONSITE_EDIT = 'CRM_MO_UPT_156',
  ONSITE_DUPLICATE = 'CRM_MO_CRT_155',
  ONSITE_SEND = 'CRM_MO_SND_157',
  ONSITE_DELETE = 'CRM_MO_DLT_158',

  /**
   * =================================================================================
   *  GAMIFICATION ACCCESS CODES
   * =================================================================================
   */

  // PLAYER DATA
  PLAYER_DATA_CRM_TABLE = '',
  PLAYER_DATA_CRM_CREATE = '',
  PLAYER_DATA_CRM_EDIT = '',

  // REWARD SHOP
  REWARD_SHOP_TABLE = 'rshop.read',
  REWARD_SHOP_ARCHIVE = 'rshop.read',
  REWARD_SHOP_CREATE = 'rshop.write',
  REWARD_SHOP_EDIT = 'rshop.write',
  REWARD_SHOP_DUPLICATE = 'rshop.write',
  REWARD_SHOP_DELETE = 'rshop.delete',
  REWARD_SHOP_RECOVER = 'rshop.recover',

  // LEVELS
  LEVELS = '',
  LEVEL_CREATE = '',
  LEVEL_EDIT = '',

  // PURCHASE
  PURCHASE_FEED_TABLE = 'rprocessor.read',
  PURCHASE_FEED_EDIT = 'rprocessor.write',

  // MISSIONS
  MISSIONS_TABLE = 'missions.read',
  MISSIONS_ARCHIVE = 'missions.read',
  MISSIONS_CREATE = 'missions.write',
  MISSIONS_EDIT = 'missions.write',
  MISSIONS_DUPLICATE = 'missions.write',
  MISSIONS_DELETE = 'missions.delete',
  MISSIONS_RECOVER = 'missions.recover',

  // MISSIONS BUNDLE
  MISSIONS_BUNDLE_TABLE = 'missions.read',
  MISSIONS_BUNDLE_ARCHIVE = 'missions.read',
  MISSIONS_BUNDLE_CREATE = 'missions.write',
  MISSIONS_BUNDLE_EDIT = 'missions.write',
  MISSIONS_BUNDLE_DUPLICATE = 'missions.write',
  MISSIONS_BUNDLE_DELETE = 'missions.delete',
  MISSIONS_BUNDLE_RECOVER = 'missions.recover',

  // TOKEN RULES
  TOKEN_RULES_TABLE = 'vcurrency.read',
  TOKEN_RULES_ARCHIVE = 'vcurrency.read',
  TOKEN_RULES_CREATE = 'vcurrency.write',
  TOKEN_RULES_EDIT = 'vcurrency.write',
  TOKEN_RULES_DUPLICATE = 'vcurrency.write',
  TOKEN_RULES_DELETE = 'vcurrency.delete',
  TOKEN_RULES_RECOVER = 'vcurrency.recover',
  TOKEN_BULK_HISTORY = 'vcurrency.read',
  TOKEN_BULK_DETAILS = 'vcurrency.read',
  TOKEN_BULK_ADD = 'vcurrency.write',

  // XP POINT RULES
  XP_POINT_RULES_TABLE = 'ranks.read',
  XP_POINT_RULES_ARCHIVE = 'ranks.read',
  XP_POINT_RULES_CREATE = 'ranks.write',
  XP_POINT_RULES_EDIT = 'ranks.write',
  XP_POINT_RULES_DUPLICATE = 'ranks.write',
  XP_POINT_RULES_DELETE = 'ranks.delete',
  XP_POINT_RULES_RECOVER = 'ranks.recover',
  XP_POINT_BULK_HISTORY = 'ranks.read',
  XP_POINT_BULK_DETAILS = 'ranks.read',
  XP_POINT_BULK_ADD = 'ranks.write',

  // PLAYER CATEGORY
  PLAYER_CATEGORY_TABLE = 'ranks.read',
  PLAYER_CATEGORY_ARCHIVE = 'ranks.read',
  PLAYER_CATEGORY_CREATE = 'ranks.write',
  PLAYER_CATEGORY_EDIT = 'ranks.write',
  PLAYER_CATEGORY_DUPLICATE = 'ranks.write',
  PLAYER_CATEGORY_DELETE = 'ranks.delete',
  PLAYER_CATEGORY_RECOVER = 'ranks.recover',

  // RANK
  RANK_TABLE = 'ranks.read',
  RANK_ARCHIVE = 'ranks.read',
  RANK_CREATE = 'ranks.write',
  RANK_EDIT = 'ranks.write',
  RANK_DUPLICATE = 'ranks.write',
  RANK_DELETE = 'ranks.delete',
  RANK_RECOVER = 'ranks.recover',

  // TOURNAMENT
  TOURNAMENT_TABLE = 'tournaments.read',
  TOURNAMENT_ARCHIVE = 'tournaments.read',
  TOURNAMENT_CREATE = 'tournaments.write',
  TOURNAMENT_EDIT = 'tournaments.write',
  TOURNAMENT_DUPLICATE = 'tournaments.write',
  TOURNAMENT_DELETE = 'tournaments.delete',
  TOURNAMENT_RECOVER = 'tournaments.recover',

  //  CATALOG
  CATALOG_TABLE = 'gcatalog.read',
  CATALOG_CREATE = 'gcatalog.write',
  CATALOG_EDIT = 'gcatalog.write',
  CATALOG_DELETE = 'gcatalog.delete',

  // PRIZESHARK
  PRIZESHARK_TABLE = '',
  PRIZESHARK_CREATE = '',
  PRIZESHARK_EDIT = '',
  PRIZESHARK_DELETE = '',

  /**
   * =================================================================================
   *  PLAYER CARD ACCCESS CODES
   * =================================================================================
   */

  PLAYER_CARD_PERSONALIZATION_ENGINE = 'ADM_PC_PZE_138',
  PLAYER_CARD_CAMPAIGN_HISTORY = 'ADM_PC_CPH_139',
  PLAYER_CARD_MISSION_HISTORY = 'missions.read',
  PLAYER_CARD_MISSION_COMPLETE_OBJECTIVE = 'missions.write',
  PLAYER_CARD_MY_REWARDS = 'rprocessor.read',
  PLAYER_CARD_MY_REWARDS_CLAIM = 'rprocessor.write',
  PLAYER_CARD_MY_REWARDS_DELETE = 'rprocessor.delete',
  PLAYER_CARD_LEVEL_HISTORY = 'ranks.read',
  PLAYER_CARD_XP_HISTORY = 'ranks.read',
  PLAYER_CARD_XP_ADJUST = 'ranks.write',
  PLAYER_CARD_TOKEN_HISTORY = 'vcurrency.read',
  PLAYER_CARD_TOKEN_ADJUST = 'vcurrency.write',
  PLAYER_CARD_TOURNAMENTS = 'tournaments.read',
}
